module.exports = __webpack_public_path__ + "img/sales.27228e68.svg";